window.onload = () => {
	toggleTabs()
}

/**
 * Toggles active state for tabs.
 */
const toggleTabs = () => {
	const tabBlock = document.querySelectorAll('.wp-block-nrtc-blocks-tabs')

	tabBlock.forEach((block) => {
		const allItems = block.querySelectorAll('[data-id]')
		const tabs = block.querySelectorAll('.tabNavigation li')

		// add event listener to each tab.
		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => {
				allItems.forEach(item => {
					if (item.dataset.id != index) {
						item.classList.remove('active')
					} else {
						item.classList.add('active')
					}
				})
			})
		})
	})
}
